import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { useIntl } from 'react-intl';
import { StationAuditPage } from '../../components/StationAuditPage';
import { SchedulesRootView } from './SchedulesRootView';

export function StationSchedulesListPage() {
  const station = useActiveStation();
  const { $t } = useIntl();

  return (
    <StationAuditPage
      title={$t({
        id: 'audit.schedulesListScreen.title',
        defaultMessage: 'Programación',
      })}
    >
      <SchedulesRootView station={station} />
    </StationAuditPage>
  );
}
